export default __webpack_public_path__ + "static/media/youtube.7cedfa3a.png";